import useLoad from 'components/hooks/useLoad';
import {integrityProfile} from 'constants/url';

function useLoadIntegrityProfile(selection: any) {
  return useLoad(integrityProfile, 'revision', {values: selection});
}

export default useLoadIntegrityProfile;
